export function DocumentsPage() {
  return <div />
}
